<template>
  <button
    type="button"
    class="bg-background-info-primary/10 flex w-full items-center space-x-3 rounded-2xl p-3"
    @click="emit('onLabelClick')"
  >
    <div class="bg-background-info-primary rounded-md px-1.5 py-1">
      <p class="text-3xs text-static-white font-bold">
        {{ $t('details.warnings.smartLabel') }}
      </p>
    </div>
    <p
      class="text-text-neutral-primary line-clamp-2 overflow-hidden text-ellipsis text-left text-xs"
    >
      {{ $t('details.warnings.smartRoute') }}
    </p>
    <ChevronIcon class="text-background-info-primary shrink-0" />
  </button>
</template>

<script setup lang="ts">
  import ChevronIcon from '@/assets/images/chevron-arrow-24x24.svg?component';

  const emit = defineEmits<{ onLabelClick: [] }>();
</script>
